module.exports = __webpack_public_path__ + "static/img/F02-合肥新华公学1.6a55e4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F02-合肥新华公学1.png
// module id = SEfD
// module chunks = 0